// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  padding: 0;
  margin: 0;
  /* font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif; */
}
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video,
button,
textarea {
  margin: 0;
  padding: 0;
  border: 0;
}
* {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
}
h1,
h2,
h3,
h4,
h5,
h6,
i,
b,
strong {
  font-weight: normal;
}
ul,
ol {
  list-style: none;
}
img {
  display: block;
}
a,
u {
  text-decoration: none;
}
i,
b,
strong {
  font-style: normal;
}
table {
  border-collapse: collapse;
  table-layout: fixed;
}
input,
textarea,
button {
  outline: none !important;
  border: none;
  background-color: transparent;
}
input::selection,
textarea::selection {
  background-color: #fff !important;
  color: #333;
}
input::selection,
textarea::selection,
button::selection {
  background-color: transparent;
}
[contenteditable="true"],
input,
textarea {
  line-height: 20px;
  -webkit-user-select: auto;
  -khtml-user-select: auto;
  -moz-user-select: auto;
  -ms-user-select: auto;
  -o-user-select: auto;
  user-select: auto;
}
textarea {
  resize: none;
  overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./src/styles/reset.less"],"names":[],"mappings":"AAAA;;EAEE,UAAA;EACA,SAAA;EACA;2EACyE;AAC3E;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAaC,SAAA;EACA,UAAA;EACA,SAAA;AAsED;AAnEA;EACE,sBAAA;EACA,wCAAA;EACA,mCAAA;AAqEF;AAlEA;;;;;;;;;EACI,mBAAA;AA4EJ;AAzEA;;EACI,gBAAA;AA4EJ;AAzEA;EACI,cAAA;AA2EJ;AAxEA;;EACI,qBAAA;AA2EJ;AAxEA;;;EACI,kBAAA;AA4EJ;AAzEA;EACI,yBAAA;EACA,mBAAA;AA2EJ;AAxEA;;;EACI,wBAAA;EACA,YAAA;EACA,6BAAA;AA4EJ;AAzEA;;EAEI,iCAAA;EACA,WAAA;AA2EJ;AAxEA;;;EACI,6BAAA;AA4EJ;AAzEA;;;EACI,iBAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;AA6EJ;AA1EA;EACI,YAAA;EACA,cAAA;AA4EJ","sourcesContent":["html,\nbody {\n  padding: 0;\n  margin: 0;\n  /* font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,\n    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif; */\n}\n    \nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed,\nfigure, figcaption, footer, header, hgroup,\nmenu, nav, output, ruby, section, summary,\ntime, mark, audio, video, button, textarea {\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0\n}\n\n* {\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-font-smoothing: antialiased\n}\n\nh1, h2, h3, h4, h5, h6, i, b, strong {\n    font-weight: normal\n}\n\nul, ol {\n    list-style: none\n}\n\nimg {\n    display: block\n}\n\na, u {\n    text-decoration: none\n}\n\ni, b, strong {\n    font-style: normal\n}\n\ntable {\n    border-collapse: collapse;\n    table-layout: fixed\n}\n\ninput, textarea, button {\n    outline: none !important;\n    border: none;\n    background-color: transparent;\n}\n\ninput::selection,\ntextarea::selection {\n    background-color: #fff !important;\n    color: #333\n}\n\ninput::selection, textarea::selection, button::selection {\n    background-color: transparent\n}\n\n[contenteditable=\"true\"], input, textarea {\n    line-height: 20px;\n    -webkit-user-select: auto;\n    -khtml-user-select: auto;\n    -moz-user-select: auto;\n    -ms-user-select: auto;\n    -o-user-select: auto;\n    user-select: auto\n}\n\ntextarea {\n    resize: none;\n    overflow: auto\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
